import { z } from "zod";

const productUpdateSchema = z.object({
    name: z.optional(z.string({ message: "name should be a string" })),
    sellingPrice: z.optional(z.coerce.number({ message: "Selling price should be a number" })),
    buyingPrice: z.optional(z.coerce.number({ message: "Buying price should be a number" })),
    stock: z.optional(z.coerce.number({ message: "Stock should be a number" })),
    gst: z.optional(z.coerce.number({ message: "GST should be a number" }).max(100, { message: "GST should be less than or equal to 100" })),
    discount: z.optional(z.coerce.number({ message: "Discount should be a number" }).max(100, { message: "Discount should be less than or equal to 100" })),
    MRP: z.optional(z.coerce.number({ message: "MRP should be a number" })),
    category: z.optional(z.string({ message: "Category should be a string" })),
    materialCode: z.optional(z.string({ message: "Material code should be a string" }))
})

export default productUpdateSchema;